if (!customElements.get("fabric-zoom")) {
    class FabricZoom extends HTMLElement {
        connectedCallback() {
            this.image = this.querySelector("[data-fabric-zoom-image]");
            this.caption = this.querySelector("[data-fabric-zoom-title]");

            // Capture phase: the button sits inside a swatch label, so the click has to be
            // stopped before the label selects that fabric.
            document.addEventListener(
                "click",
                (event) => {
                    const trigger = event.target.closest("[data-swatch-zoom]");

                    if (!trigger) return;

                    event.preventDefault();
                    event.stopPropagation();
                    this.open(trigger.dataset.swatchZoom, trigger.dataset.swatchTitle);
                },
                true
            );

            document.addEventListener("click", (event) => {
                if (this.hidden) return;

                if (event.target.closest("[data-fabric-zoom-close]") || event.target === this) {
                    this.close();
                }
            });

            window.addEventListener("keydown", (event) => {
                if (event.key === "Escape" && !this.hidden) this.close();
            });
        }

        open(src, title) {
            if (!src) return;

            // Zdjecie ma 1400 px, wiec przez chwile nie ma czego pokazac - bez tego
            // overlay stoi pusty i wyglada jak zawieszony.
            this.classList.add("loading");
            this.image.removeAttribute("src");

            const done = () => this.classList.remove("loading");

            this.image.onload = done;
            this.image.onerror = done;
            this.image.src = src;
            this.image.alt = title || "";
            this.caption.textContent = title || "";
            this.hidden = false;
            document.body.classList.add("drawer-locked");

            if (this.image.complete) done();
        }

        close() {
            this.hidden = true;
            document.body.classList.remove("drawer-locked");
        }
    }

    customElements.define("fabric-zoom", FabricZoom);
}
